import {ErrorHandler, Inject, Injectable, Injector, NgZone, PLATFORM_ID, SecurityContext} from "@angular/core";
import {Store} from '@ngrx/store';
import {setNotification} from '@iw-shared/store/actions/global.actions';
import {isPlatformBrowser} from "@angular/common";
import {DomSanitizer} from "@angular/platform-browser";


/*
export function writeErrorToHTMLIfAppNotInitialized(error: string) {
    let buttonDebug = document.querySelector(".button-bug");
    if (!buttonDebug && error.length > 0) {
        let divConainerError = document.querySelector("#my-error-container");
        if(!divConainerError){
            let divConainerInitialLoading = document.querySelector("#initial-loading");
            divConainerError = document.createElement("div") as HTMLElement;
            divConainerError.id = 'my-error-container';
            divConainerError.classList.add('container', 'p-2-mobile');
            if(divConainerInitialLoading){
                divConainerInitialLoading.innerHTML = '';
                divConainerInitialLoading.appendChild(divConainerError);
            } else {
                document.body.appendChild(divConainerError);
            }

        }
        let divError = document.createElement("div");
        divError.innerHTML = '<div class="error-msg m-3 notification is-danger">' + error + '</div>';
        divConainerError.prepend(divError)

    }
}
*/

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

    isBrowser: boolean;
    constructor(private injector: Injector, private zone: NgZone, @Inject(PLATFORM_ID) platformId: Object, private sanitizer: DomSanitizer) {
        this.isBrowser = isPlatformBrowser(platformId);
    }



    handleError(error: Error) {
        const store = this.injector.get(Store);
        console.log('log error', error);
        if (error?.stack) {
            error.message = error.message + '<br>' + error.stack;
        }
        this.zone.run(() => {
                let errorMsg = '';
                if (error?.name) {
                    errorMsg = '<b>' + error?.name + '</b><br>'
                }
                if (error?.stack) {
                    errorMsg = errorMsg + '' + error?.stack + '><br>'
                }
                if (error?.message) {
                    errorMsg = errorMsg + '' + error?.message + '><br>'
                }

                store.dispatch(setNotification({notification: errorMsg, notificationType: 'error'}));
                /*if(this.isBrowser){
                    setTimeout(() => {
                        writeErrorToHTMLIfAppNotInitialized(this.sanitizer.sanitize(SecurityContext.HTML, errorMsg)?.toString() ?? '');
                    }, 100);
                }*/


            }
        );
        return;
    }
}
